import { forwardRef } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import type {
  TDropdownMenuSeparatorElement,
  TDropdownMenuSeparatorProps,
} from "@/ui/components/overlay/DropdownMenu/DropdownMenu.config";
import { cn } from "@/ui/lib/utils";

export const DropdownMenuSeparator = forwardRef<TDropdownMenuSeparatorElement, TDropdownMenuSeparatorProps>(
  (
    {
      className,
      ...props
    },
    ref,
  ) => (
    <DropdownMenuPrimitive.Separator
      data-component="DropdownMenuSeparator"
      ref={ref}
      className={cn("-mx-1 my-1 h-px bg-component-dropdown-separator", className)}
      {...props}
    />
  ),
);

DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
